import { createContext } from 'react';

export const PaswordRecoveryContext = createContext(null);
